import classNames from 'classnames';

import { JabraSlide } from 'common/components/JabraSlider/JabraSlider';
import styles from 'composables/Product/Buy/ImageSlider/ImageSlider.module.scss';

let keyCounter = 0;

const PlaceholderSlide = () => {
  const key = `placeholder-${keyCounter++}`;
  return (
    <JabraSlide
      key={key}
      renderThumbnail={(selected) => (
        <div
          className={classNames(
            'animate-glow bg-black bg-opacity-8 outline-2 outline-focus group-focus-visible/slider-thumbnail:outline dark:bg-opacity-24',
            styles.smallThumb,
            selected && 'border border-primary'
          )}
        />
      )}
    >
      <div className="animate-glow h-[12.5rem] w-[12.5rem] rounded max-md:my-8 max-sm:my-16 sm:h-[18.75rem] sm:w-[18.75rem] xl:h-[31.25rem] xl:w-[31.25rem]" />
    </JabraSlide>
  );
};

export default PlaceholderSlide;
